/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends, __values } from "tslib";
import { AnnotationLayer } from "./AnnotationLayer";
import { Axis } from "./Axis";
import { DependencyProperty } from "igniteui-react-core";
import { DataToolTipLayerGroupingMode_$type } from "igniteui-react-core";
import { Series } from "./Series";
import { Rect } from "igniteui-react-core";
import { Base, enumGetBox, EnumUtil, fromEnum, typeCast, String_$type, typeGetValue, Point_$type, Array_$type, markType, markDep, runOn, TypeRegistrar } from "igniteui-react-core";
import { Size } from "igniteui-react-core";
import { RectUtil } from "igniteui-react-core";
import { DataTooltipGroupedPositionX_$type } from "igniteui-react-core";
import { DataTooltipGroupedPositionY_$type } from "igniteui-react-core";
import { DataAbbreviationMode_$type } from "igniteui-react-core";
import { DataLegendValueMode_$type } from "igniteui-react-core";
import { Thickness } from "igniteui-react-core";
import { Brush } from "igniteui-react-core";
import { DataLegendHeaderDateMode_$type } from "igniteui-react-core";
import { DataLegendHeaderTimeMode_$type } from "igniteui-react-core";
import { DataLegendSummaryType_$type } from "igniteui-react-core";
import { LegendItemBadgeShape_$type } from "igniteui-react-core";
import { DataLegendUnitsMode_$type } from "igniteui-react-core";
import { DataLegendLabelMode_$type } from "igniteui-react-core";
import { DataToolTipLayerFrame } from "./DataToolTipLayerFrame";
import { Dictionary$2 } from "igniteui-react-core";
import { List$1 } from "igniteui-react-core";
import { Pool$1 } from "igniteui-react-core";
import { DataToolTipSeriesInfo } from "./DataToolTipSeriesInfo";
import { DataContext } from "igniteui-react-core";
import { DataTooltipCollisionInfo } from "./DataTooltipCollisionInfo";
import { DeviceUtils } from "igniteui-react-core";
import { HashSet$1 } from "igniteui-react-core";
import { PropertyMetadata } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
import { stringEmpty } from "igniteui-react-core";
import { AnnotationLayerView } from "./AnnotationLayerView";
import { PointerTooltip } from "./PointerTooltip";
import { IOnDemandRender_$type } from "igniteui-react-core";
/**
 * @hidden
 */
var DataToolTipLayer = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(DataToolTipLayer, _super);
    function DataToolTipLayer() {
        var _this = _super.call(this) || this;
        _this.t0 = 1;
        _this.u2 = new Dictionary$2(String_$type, Base.$, 0);
        _this.u3 = new List$1(String_$type, 0);
        _this.ts = 8;
        _this.tw = 11;
        _this.uf = null;
        _this.t7 = null;
        _this.ua = null;
        _this.uc = null;
        _this.t9 = null;
        _this.ub = null;
        _this.ue = null;
        _this.ud = null;
        _this.t8 = null;
        var a = new DataToolTipLayerFrame();
        var b = new DataToolTipLayerFrame();
        var c = new DataToolTipLayerFrame();
        _this.qq = a;
        _this.qp = b;
        _this.qr = c;
        _this.ab = DataToolTipLayer.$;
        return _this;
    }
    DataToolTipLayer.prototype.get_dc = function () {
        return true;
    };
    DataToolTipLayer.prototype.by = function () {
        return new DataToolTipLayerView(this);
    };
    DataToolTipLayer.prototype.l4 = function (a) {
        _super.prototype.l4.call(this, a);
        this.t4 = a;
    };
    DataToolTipLayer.prototype.get_dn = function () {
        return true;
    };
    Object.defineProperty(DataToolTipLayer.prototype, "t1", {
        get: function () {
            return this.t0;
        },
        set: function (a) {
            var b = this.t0;
            this.t0 = a;
            if (b != this.t0) {
                this.raisePropertyChanged("ActualGroupingMode", enumGetBox(DataToolTipLayerGroupingMode_$type, b), enumGetBox(DataToolTipLayerGroupingMode_$type, this.t0));
            }
        },
        enumerable: false,
        configurable: true
    });
    DataToolTipLayer.prototype.t3 = function () {
        var e_1, _a;
        var a = true;
        var b = true;
        var c = true;
        var d = true;
        if (this.t2 != 0) {
            return this.t2;
        }
        var e = this.tj();
        if (e != null) {
            try {
                for (var _b = __values(fromEnum(e.db())), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var f = _c.value;
                    if (!f.dd && !f.ef) {
                        a = false;
                    }
                    if (!f.dd && !f.d9) {
                        b = false;
                    }
                    if (!f.dd && !f.eg) {
                        c = false;
                    }
                    if (!f.dd && !f.ed) {
                        d = false;
                    }
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
        }
        if (a || b || c || d) {
            return 2;
        }
        return 1;
    };
    DataToolTipLayer.prototype.l9 = function (a, b, c, d) {
        _super.prototype.l9.call(this, a, b, c, d);
        switch (b) {
            case DataToolTipLayer.$$p[37]:
                this.mn(true);
                break;
            case DataToolTipLayer.$$p[44]:
                this.mn(true);
                break;
            case DataToolTipLayer.$$p[8]:
                this.t1 = this.t3();
                break;
            case "ActualGroupingMode":
                this.mn(true);
                break;
            case DataToolTipLayer.$$p[6]:
                this.tt = this.tv();
                break;
            case DataToolTipLayer.$$p[7]:
                this.tx = this.tz();
                break;
            case "SeriesViewer":
                this.t4.ci();
                break;
            case DataToolTipLayer.$$p[26]:
            case DataToolTipLayer.$$p[20]:
            case DataToolTipLayer.$$p[5]:
            case DataToolTipLayer.$$p[19]:
            case DataToolTipLayer.$$p[4]:
            case DataToolTipLayer.$$p[45]:
            case DataToolTipLayer.$$p[47]:
            case DataToolTipLayer.$$p[48]:
            case DataToolTipLayer.$$p[49]:
            case DataToolTipLayer.$$p[46]:
            case DataToolTipLayer.$$p[52]:
            case DataToolTipLayer.$$p[51]:
            case DataToolTipLayer.$$p[50]:
            case DataToolTipLayer.$$p[53]:
            case DataToolTipLayer.$$p[54]:
            case DataToolTipLayer.$$p[58]:
            case DataToolTipLayer.$$p[57]:
            case DataToolTipLayer.$$p[56]:
            case DataToolTipLayer.$$p[55]:
            case "ValueTextStyle":
            case DataToolTipLayer.$$p[12]:
            case DataToolTipLayer.$$p[11]:
            case DataToolTipLayer.$$p[9]:
            case DataToolTipLayer.$$p[10]:
            case DataToolTipLayer.$$p[13]:
            case DataToolTipLayer.$$p[18]:
            case DataToolTipLayer.$$p[16]:
            case DataToolTipLayer.$$p[17]:
            case DataToolTipLayer.$$p[14]:
            case DataToolTipLayer.$$p[15]:
            case "HeaderTextStyle":
            case DataToolTipLayer.$$p[30]:
            case "SummaryTitleTextStyle":
            case DataToolTipLayer.$$p[33]:
            case DataToolTipLayer.$$p[32]:
            case DataToolTipLayer.$$p[31]:
            case DataToolTipLayer.$$p[29]:
            case DataToolTipLayer.$$p[36]:
            case "SummaryValueTextStyle":
            case DataToolTipLayer.$$p[28]:
            case DataToolTipLayer.$$p[27]:
            case "SummaryLabelTextStyle":
            case DataToolTipLayer.$$p[35]:
            case DataToolTipLayer.$$p[34]:
            case "SummaryUnitsTextStyle":
            case DataToolTipLayer.$$p[0]:
            case DataToolTipLayer.$$p[1]:
            case DataToolTipLayer.$$p[40]:
            case DataToolTipLayer.$$p[43]:
            case DataToolTipLayer.$$p[41]:
            case DataToolTipLayer.$$p[42]:
            case "UnitsTextStyle":
            case DataToolTipLayer.$$p[39]:
            case DataToolTipLayer.$$p[38]:
            case "TitleTextStyle":
            case DataToolTipLayer.$$p[21]:
            case DataToolTipLayer.$$p[22]:
            case DataToolTipLayer.$$p[23]:
            case "LabelTextStyle":
                this.yk(b, c, d);
                break;
        }
    };
    DataToolTipLayer.prototype.yk = function (a, b, c) {
        if (!this.u2.containsKey(a)) {
            this.u3.add(a);
            this.u2.addItem(a, c);
        }
        else {
            this.u2.item(a, c);
        }
        this.mn(true);
    };
    DataToolTipLayer.prototype.yo = function (a, b) {
        switch (a) {
            case DataToolTipLayer.$$p[8]:
                this.t2 = EnumUtil.getEnumValue(DataToolTipLayerGroupingMode_$type, b);
                break;
            case DataToolTipLayer.$$p[24]:
                this.u7 = b;
                break;
            case DataToolTipLayer.$$p[25]:
                this.u8 = b;
                break;
            case DataToolTipLayer.$$p[2]:
                this.u5 = b;
                break;
            case DataToolTipLayer.$$p[3]:
                this.u6 = b;
                break;
            case DataToolTipLayer.$$p[6]:
                this.tu = EnumUtil.getEnumValue(DataTooltipGroupedPositionX_$type, b);
                break;
            case DataToolTipLayer.$$p[7]:
                this.ty = EnumUtil.getEnumValue(DataTooltipGroupedPositionY_$type, b);
                break;
            case DataToolTipLayer.$$p[26]:
                this.ux = b;
                break;
            case DataToolTipLayer.$$p[20]:
                this.th = b;
                break;
            case DataToolTipLayer.$$p[5]:
                this.tc = b;
                break;
            case DataToolTipLayer.$$p[19]:
                this.tg = b;
                break;
            case DataToolTipLayer.$$p[4]:
                this.tb = b;
                break;
            case DataToolTipLayer.$$p[45]:
                this.tl = EnumUtil.getEnumValue(DataAbbreviationMode_$type, b);
                break;
            case DataToolTipLayer.$$p[47]:
                this.v7 = typeGetValue(b);
                break;
            case DataToolTipLayer.$$p[48]:
                this.v8 = typeGetValue(b);
                break;
            case DataToolTipLayer.$$p[49]:
                this.tr = EnumUtil.getEnumValue(DataLegendValueMode_$type, b);
                break;
            case DataToolTipLayer.$$p[46]:
                this.x2 = b;
                break;
            case DataToolTipLayer.$$p[52]:
                this.uz = b;
                break;
            case DataToolTipLayer.$$p[51]:
                this.x8 = b;
                break;
            case DataToolTipLayer.$$p[50]:
                this.ti = b;
                break;
            case DataToolTipLayer.$$p[53]:
                this.aaz = b;
                break;
            case DataToolTipLayer.$$p[54]:
                this.u0 = b;
                break;
            case DataToolTipLayer.$$p[58]:
                this.yh = b;
                break;
            case DataToolTipLayer.$$p[57]:
                this.u1 = b;
                break;
            case DataToolTipLayer.$$p[56]:
                this.aa0 = b;
                break;
            case DataToolTipLayer.$$p[55]:
                this.aak = b;
                break;
            case "ValueTextStyle":
                this.uo = b;
                break;
            case DataToolTipLayer.$$p[12]:
                this.wq = b;
                break;
            case DataToolTipLayer.$$p[11]:
                this.tf = b;
                break;
            case DataToolTipLayer.$$p[9]:
                this.wm = b;
                break;
            case DataToolTipLayer.$$p[10]:
                this.tm = EnumUtil.getEnumValue(DataLegendHeaderDateMode_$type, b);
                break;
            case DataToolTipLayer.$$p[13]:
                this.tn = EnumUtil.getEnumValue(DataLegendHeaderTimeMode_$type, b);
                break;
            case DataToolTipLayer.$$p[18]:
                this.wv = b;
                break;
            case DataToolTipLayer.$$p[16]:
                this.aac = b;
                break;
            case DataToolTipLayer.$$p[17]:
                this.aat = b;
                break;
            case DataToolTipLayer.$$p[14]:
                this.aas = b;
                break;
            case DataToolTipLayer.$$p[15]:
                this.uq = b;
                break;
            case "HeaderTextStyle":
                this.ug = b;
                break;
            case DataToolTipLayer.$$p[30]:
                this.aaf = b;
                break;
            case "SummaryTitleTextStyle":
                this.uj = b;
                break;
            case DataToolTipLayer.$$p[33]:
                this.tp = EnumUtil.getEnumValue(DataLegendSummaryType_$type, b);
                break;
            case DataToolTipLayer.$$p[32]:
                this.xe = b;
                break;
            case DataToolTipLayer.$$p[31]:
                this.aaw = b;
                break;
            case DataToolTipLayer.$$p[29]:
                this.aav = b;
                break;
            case DataToolTipLayer.$$p[36]:
                this.aah = b;
                break;
            case "SummaryValueTextStyle":
                this.ul = b;
                break;
            case DataToolTipLayer.$$p[28]:
                this.w9 = b;
                break;
            case DataToolTipLayer.$$p[27]:
                this.aae = b;
                break;
            case "SummaryLabelTextStyle":
                this.ui = b;
                break;
            case DataToolTipLayer.$$p[35]:
                this.xk = b;
                break;
            case DataToolTipLayer.$$p[34]:
                this.aag = b;
                break;
            case "SummaryUnitsTextStyle":
                this.uk = b;
                break;
            case DataToolTipLayer.$$p[0]:
                this.aar = b;
                break;
            case DataToolTipLayer.$$p[1]:
                this.t6 = EnumUtil.getEnumValue(LegendItemBadgeShape_$type, b);
                break;
            case DataToolTipLayer.$$p[40]:
                this.tq = EnumUtil.getEnumValue(DataLegendUnitsMode_$type, b);
                break;
            case DataToolTipLayer.$$p[43]:
                this.xv = b;
                break;
            case DataToolTipLayer.$$p[41]:
                this.aaj = b;
                break;
            case DataToolTipLayer.$$p[42]:
                this.aay = b;
                break;
            case "UnitsTextStyle":
                this.un = b;
                break;
            case DataToolTipLayer.$$p[39]:
                this.aax = b;
                break;
            case DataToolTipLayer.$$p[38]:
                this.aai = b;
                break;
            case "TitleTextStyle":
                this.um = b;
                break;
            case DataToolTipLayer.$$p[21]:
                this.to = EnumUtil.getEnumValue(DataLegendLabelMode_$type, b);
                break;
            case DataToolTipLayer.$$p[22]:
                this.aad = b;
                break;
            case DataToolTipLayer.$$p[23]:
                this.aau = b;
                break;
            case "LabelTextStyle":
                this.uh = b;
                break;
        }
    };
    DataToolTipLayer.prototype.yl = function (a) {
        for (var b = 0; b < this.u3.count; b++) {
            var c = this.u3._inner[b];
            a.updatePropertyByName(c, this.u2.item(c));
        }
    };
    DataToolTipLayer.prototype.r2 = function (a, b) {
        {
            if (!this.at.c) {
                this.mn(b);
            }
        }
    };
    DataToolTipLayer.prototype.r3 = function (a, b) {
        if (!this.at.c) {
            this.mn(b);
        }
    };
    DataToolTipLayer.prototype.r5 = function (a, b) {
        var e_2, _a;
        var _this = this;
        _super.prototype.r5.call(this, a, b);
        this.t0 = this.t3();
        var c = a;
        var d = this.t4.b6;
        var e = this.uy;
        var f = false;
        c.m.clear();
        c.i.clear();
        c.l.clear();
        c.g.clear();
        c.f.clear();
        c.k.clear();
        c.j.clear();
        c.h.clear();
        if (isNaN_(this.s8.x) && isNaN_(this.s8.y)) {
            d.count = 0;
            return;
        }
        {
            if (this.t1 == 2) {
                var g_1 = 0;
                {
                    try {
                        for (var _b = __values(fromEnum(this.ce.series)), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var h = _c.value;
                            if (this.qw(h)) {
                                this.yn(h, c, e, f, g_1);
                                g_1++;
                            }
                            if (h.isStacked) {
                                h.lf(function (i) {
                                    if (_this.qw(i)) {
                                        _this.yn(i, c, e, f, g_1);
                                        g_1++;
                                    }
                                    return true;
                                });
                            }
                        }
                    }
                    catch (e_2_1) {
                        e_2 = { error: e_2_1 };
                    }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return))
                                _a.call(_b);
                        }
                        finally {
                            if (e_2)
                                throw e_2.error;
                        }
                    }
                    this.yj(c);
                }
                d.count = g_1;
            }
            else {
                var i = this.tj();
                var j = this.u4(i);
                var k = this.t5(i, j, e);
                this.ym(k, c, e);
            }
        }
    };
    DataToolTipLayer.prototype.u4 = function (a) {
        var e_3, _a;
        var b = new List$1(Series.$, 0);
        if (a == null) {
            return b;
        }
        try {
            for (var _b = __values(fromEnum(a.de)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var c = _c.value;
                b.add(c);
            }
        }
        catch (e_3_1) {
            e_3 = { error: e_3_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_3)
                    throw e_3.error;
            }
        }
        return b;
    };
    DataToolTipLayer.prototype.tj = function () {
        var e_4, _a, e_5, _b;
        if (this.tk != null) {
            return this.tk;
        }
        if (this.ce == null) {
            return null;
        }
        try {
            for (var _c = __values(fromEnum(this.ce.series)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var a = _d.value;
                if (a.dj) {
                    var b = a.as();
                    if (b != null && b.co()) {
                        return b;
                    }
                }
            }
        }
        catch (e_4_1) {
            e_4 = { error: e_4_1 };
        }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return))
                    _a.call(_c);
            }
            finally {
                if (e_4)
                    throw e_4.error;
            }
        }
        try {
            for (var _e = __values(fromEnum(this.ce.series)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var c = _f.value;
                if (!c.dj) {
                    var d = c.ag();
                    var e = d != null && d.length > 0 ? d[0] : null;
                    if (e != null && e.co()) {
                        return e;
                    }
                }
            }
        }
        catch (e_5_1) {
            e_5 = { error: e_5_1 };
        }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return))
                    _b.call(_e);
            }
            finally {
                if (e_5)
                    throw e_5.error;
            }
        }
        return null;
    };
    DataToolTipLayer.prototype.t5 = function (a, b, c) {
        var d = 1.7976931348623157E+308;
        var e = -1.7976931348623157E+308;
        var f = new List$1(DataContext.$, 0);
        var g = new List$1(Base.$, 0);
        var h = false;
        var i = true;
        var j = { $type: Point_$type, x: NaN, y: NaN };
        var k = 0;
        var l = 0;
        var _loop_1 = function (m) {
            var n = b.item(m);
            k = n.ce.l;
            l = n.ce.m;
            if (n.dj) {
                var o = n;
                var p_1 = new List$1(Series.$, 0);
                if (o.isStacked) {
                    o.lf(function (q) {
                        p_1.add(q);
                        return true;
                    });
                }
                else {
                    p_1.add(o);
                }
                for (var q = 0; q < p_1.count; q++) {
                    var r = p_1._inner[q];
                    var s = p_1._inner[q];
                    if (!r.categoryAxis.co()) {
                        continue;
                    }
                    if (i) {
                        h = s.isVertical;
                    }
                    else {
                        if (h != s.isVertical) {
                            continue;
                        }
                    }
                    var t = this_1.ry(s);
                    if (!t.c) {
                        continue;
                    }
                    j = s.pn(t.d);
                    var u = s.ps(t.d, c, false);
                    if (h) {
                        if (!isNaN_(u.y)) {
                            d = Math.min(d, u.y);
                            e = Math.max(e, u.y);
                        }
                    }
                    else {
                        if (!isNaN_(u.x)) {
                            d = Math.min(d, u.x);
                            e = Math.max(e, u.x);
                        }
                    }
                }
            }
            else {
                var v = n.ag();
                for (var w = 0; w < v.length; w++) {
                    if (!v[w].co()) {
                        continue;
                    }
                }
                var x = n.ps(this_1.s8, c, false);
                j = n.pn(this_1.s8);
                if (h) {
                    if (!isNaN_(x.y)) {
                        d = Math.min(d, x.y);
                        e = Math.max(e, x.y);
                    }
                }
                else {
                    if (!isNaN_(x.x)) {
                        d = Math.min(d, x.x);
                        e = Math.max(e, x.x);
                    }
                }
            }
            var y = null;
            var z = n.hy(this_1.s8);
            if (n.dp && z != null) {
                y = n.av(z);
            }
            else {
                y = new DataContext();
                y.item = z;
                y.series = n;
            }
            f.add(y);
        };
        var this_1 = this;
        for (var m = 0; m < b.count; m++) {
            _loop_1(m);
        }
        var aa = 0;
        var ab = 0;
        if (h) {
            ab = (d + e) / 2;
            aa = this.p7.right;
            if (!isNaN_(j.x)) {
                aa = j.x;
            }
            if (ab < 0 || ab > this.p7.bottom) {
                ab = NaN;
            }
        }
        else {
            aa = (d + e) / 2;
            if (!isNaN_(j.y)) {
                ab = j.y;
            }
            if (aa < 0 || aa > this.p7.right) {
                aa = NaN;
            }
        }
        var ac = new DataToolTipSeriesInfo();
        ac.f = { $type: Point_$type, x: aa, y: ab };
        ac.e = { $type: Point_$type, x: j.x, y: j.y };
        ac.b = f;
        ac.a = h;
        return ac;
    };
    DataToolTipLayer.prototype.li = function () {
        this.s8 = { $type: Point_$type, x: NaN, y: NaN };
        this.mn(false);
        this.t4.cg(false);
    };
    DataToolTipLayer.prototype.lj = function () {
        this.s8 = { $type: Point_$type, x: NaN, y: NaN };
        this.mn(false);
        this.t4.cg(true);
    };
    Object.defineProperty(DataToolTipLayer.prototype, "aao", {
        get: function () {
            var a = RectUtil.n(this.b1.bu);
            var b = new Size(1, this.b1.bu.width, this.b1.bu.height);
            return new Rect(3, a, b);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataToolTipLayer.prototype, "aan", {
        get: function () {
            var a = RectUtil.n(this.b1.bu);
            var b = new Size(1, this.b1.bu.width, this.b1.bu.height);
            return new Rect(3, this.t4.cj(a), b);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataToolTipLayer.prototype, "aam", {
        get: function () {
            var a = new Rect(0, 0, 0, this.ce.m, this.ce.l);
            var b = RectUtil.n(a);
            var c = new Size(1, a.width, a.height);
            return new Rect(3, this.t4.cj(b), c);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataToolTipLayer.prototype, "aaq", {
        get: function () {
            var a = { $type: Point_$type, x: 0, y: 0 };
            return new Rect(3, a, this.t4.co());
        },
        enumerable: false,
        configurable: true
    });
    DataToolTipLayer.prototype.aap = function () {
        return this.aao;
    };
    DataToolTipLayer.prototype.uu = function (a, b, c) {
        if (Rect.l_op_Equality(a, Rect.empty)) {
            return false;
        }
        var d = a.top;
        return c < d;
    };
    DataToolTipLayer.prototype.ur = function (a, b, c, d) {
        if (Rect.l_op_Equality(a, Rect.empty)) {
            return false;
        }
        var e = a.bottom;
        return c + d.height >= e;
    };
    DataToolTipLayer.prototype.us = function (a, b, c) {
        if (Rect.l_op_Equality(a, Rect.empty)) {
            return false;
        }
        var d = a.left;
        return c < d;
    };
    DataToolTipLayer.prototype.ut = function (a, b, c, d) {
        if (Rect.l_op_Equality(a, Rect.empty)) {
            return false;
        }
        var e = a.right;
        return c + d.width > e;
    };
    DataToolTipLayer.prototype.vx = function (a, b) {
        return a.top + b;
    };
    DataToolTipLayer.prototype.vv = function (a, b, c) {
        return a.bottom - c.height - b;
    };
    DataToolTipLayer.prototype.vw = function (a, b) {
        return ((a.bottom + a.top) / 2) - (b.height / 2);
    };
    DataToolTipLayer.prototype.v6 = function (a, b, c, d, e) {
        var f = c.y - d.height - b;
        return f;
    };
    DataToolTipLayer.prototype.v4 = function (a, b, c, d, e) {
        var f = c.y + b;
        return f;
    };
    DataToolTipLayer.prototype.v5 = function (a, b, c, d, e) {
        var f = c.y - (d.height / 2);
        return f;
    };
    DataToolTipLayer.prototype.v0 = function (a, b, c, d, e) {
        var f = c.y - d.height;
        f = f - b;
        return f;
    };
    DataToolTipLayer.prototype.vy = function (a, b, c, d, e) {
        var f = c.y;
        f = f + b;
        return f;
    };
    DataToolTipLayer.prototype.vz = function (a, b, c, d, e) {
        var f = c.y - (d.height / 2);
        return f;
    };
    DataToolTipLayer.prototype.vg = function (a, b) {
        return a.left + b;
    };
    DataToolTipLayer.prototype.vi = function (a, b, c) {
        return (a.right - (c.width)) - b;
    };
    DataToolTipLayer.prototype.vh = function (a, b, c) {
        return ((a.right + a.left) / 2) - (c.width / 2) + b;
    };
    DataToolTipLayer.prototype.vp = function (a, b, c, d, e) {
        var f = (c.x - d.width) - b;
        return f;
    };
    DataToolTipLayer.prototype.vr = function (a, b, c, d, e) {
        var f = c.x + b;
        return f;
    };
    DataToolTipLayer.prototype.vq = function (a, b, c, d, e) {
        var f = (c.x - (d.width / 2));
        f = f + b;
        return f;
    };
    DataToolTipLayer.prototype.vm = function (a, b, c, d, e) {
        var f = c.x - d.width;
        f = f - b;
        return f;
    };
    DataToolTipLayer.prototype.vo = function (a, b, c, d, e) {
        var f = c.x;
        f = f + b;
        return f;
    };
    DataToolTipLayer.prototype.vn = function (a, b, c, d, e) {
        var f = c.x - (d.width / 2);
        f = f + b;
        return f;
    };
    DataToolTipLayer.prototype.vc = function (a, b, c, d, e, f, g, h) {
        switch (a) {
            case 1:
                {
                    return this.v0(e, b, h, f, true);
                }
            case 2:
                {
                    return this.vy(e, b, h, f, true);
                }
            case 3:
                {
                    return this.vz(e, b, h, f, true);
                }
            case 5: return this.v1(e, c, b, h, f);
            case 6: return this.v2(e, c, b, h, f);
            case 4: return this.v3(e, c, b, h, f);
            case 8: return this.vs(e, c, b, h, f);
            case 9: return this.vt(e, c, b, h, f);
            case 7: return this.vu(e, c, b, h, f);
            case 13: return this.vx(d, b);
            case 14: return this.vv(d, b, f);
            case 15: return this.vw(d, f);
            case 10: return this.v6(e, b, g, f, true);
            case 12: return this.v5(e, b, g, f, true);
            case 11:
            default: return this.v4(e, b, g, f, true);
        }
    };
    DataToolTipLayer.prototype.vj = function (a, b, c, d, e) {
        var f = d.x;
        f = f + b / 2;
        f = f - e.width;
        f = f - c;
        return f;
    };
    DataToolTipLayer.prototype.vk = function (a, b, c, d, e) {
        var f = d.x;
        f = f + b / 2;
        f = f - e.width / 2;
        f = f + c;
        return f;
    };
    DataToolTipLayer.prototype.vl = function (a, b, c, d, e) {
        var f = d.x;
        f = f + b / 2;
        f = f + c;
        return f;
    };
    DataToolTipLayer.prototype.vd = function (a, b, c, d, e) {
        var f = d.x;
        f = f - b / 2;
        f = f - e.width;
        f = f - c;
        return f;
    };
    DataToolTipLayer.prototype.ve = function (a, b, c, d, e) {
        var f = d.x;
        f = f - b / 2;
        f = f - e.width / 2;
        f = f + c;
        return f;
    };
    DataToolTipLayer.prototype.vf = function (a, b, c, d, e) {
        var f = d.x;
        f = f - b / 2;
        f = f + c;
        return f;
    };
    DataToolTipLayer.prototype.vu = function (a, b, c, d, e) {
        var f = d.y;
        f = f + b / 2;
        f = f - e.height;
        f = f - c;
        return f;
    };
    DataToolTipLayer.prototype.vt = function (a, b, c, d, e) {
        var f = d.y;
        f = f + b / 2;
        f = f - e.height / 2;
        f = f + c;
        return f;
    };
    DataToolTipLayer.prototype.vs = function (a, b, c, d, e) {
        var f = d.y;
        f = f + b / 2;
        f = f + c;
        return f;
    };
    DataToolTipLayer.prototype.v3 = function (a, b, c, d, e) {
        var f = d.y;
        f = f - b / 2;
        f = f - e.height;
        f = f - c;
        return f;
    };
    DataToolTipLayer.prototype.v2 = function (a, b, c, d, e) {
        var f = d.y;
        f = f - b / 2;
        f = f - e.height / 2;
        f = f + c;
        return f;
    };
    DataToolTipLayer.prototype.v1 = function (a, b, c, d, e) {
        var f = d.y;
        f = f - b / 2;
        f = f + c;
        return f;
    };
    DataToolTipLayer.prototype.vb = function (a, b, c, d, e, f, g, h) {
        switch (a) {
            case 10: return this.vp(e, b, g, f, true);
            case 11: return this.vr(e, b, g, f, true);
            case 12: return this.vq(e, b, g, f, true);
            case 13: return this.vg(d, b);
            case 14: return this.vi(e, b, f);
            case 15: return this.vh(e, b, f);
            case 5: return this.vf(e, c, b, h, f);
            case 6: return this.ve(e, c, b, h, f);
            case 4: return this.vd(e, c, b, h, f);
            case 8: return this.vl(e, c, b, h, f);
            case 9: return this.vk(e, c, b, h, f);
            case 7: return this.vj(e, c, b, h, f);
            case 1:
                {
                    return this.vm(e, b, h, f, true);
                }
            case 3:
                {
                    return this.vn(e, b, h, f, true);
                }
            case 2:
            default:
                {
                    return this.vo(e, b, h, f, true);
                }
        }
    };
    DataToolTipLayer.prototype.aal = function (a, b, c, d) {
        var e = this.tt;
        var f = this.tx;
        var g = this.tj();
        var h = 0;
        if (g != null && g.cb && this.ce != null) {
            h = g.getCategorySize(this.ce.tj, this.p7, this.getEffectiveViewport());
            if (g.categoryMode == 0) {
                h = 0;
            }
        }
        var i = this.u9(e);
        var j = this.va(f);
        var k = this.vb(e, i, h, this.aao, a, b, c, d);
        var l = this.vc(f, j, h, this.aao, a, b, c, d);
        var m = this.uv(a, i, k, b);
        var n = this.uw(a, j, l, b);
        if (!m) {
            var o = this.td(e);
            var p = 0;
            while (!m && p < o.length) {
                e = o[p];
                i = this.u9(e);
                k = this.vb(e, i, h, this.aao, a, b, c, d);
                m = this.uv(a, i, k, b);
                p++;
            }
        }
        if (!n) {
            var q = this.te(f);
            var r = 0;
            while (!n && r < q.length) {
                f = q[r];
                j = this.va(f);
                l = this.vc(f, j, h, this.aao, a, b, c, d);
                n = this.uw(a, j, l, b);
                r++;
            }
        }
        return { $type: Point_$type, x: k, y: l };
    };
    DataToolTipLayer.prototype.va = function (a) {
        if (!isNaN_(this.u8)) {
            return this.u8;
        }
        switch (a) {
            case 1: return this.u6;
            case 2: return this.u6;
            case 3: return 0;
            case 4: return this.u6;
            case 5: return this.u6;
            case 6: return this.u6;
            case 7: return this.u6;
            case 8: return this.u6;
            case 9: return 0;
            case 10: return this.u6;
            case 11: return this.u6;
            case 12: return 0;
            case 13: return this.u6;
            case 14: return this.u6;
            case 15: return 0;
        }
        return this.u6;
    };
    DataToolTipLayer.prototype.u9 = function (a) {
        if (!isNaN_(this.u7)) {
            return this.u7;
        }
        switch (a) {
            case 4: return this.u5;
            case 6: return 0;
            case 5: return this.u5;
            case 13: return this.u5;
            case 15: return 0;
            case 14: return this.u5;
            case 7: return this.u5;
            case 9: return 0;
            case 8: return this.u5;
            case 1: return this.u5;
            case 3: return 0;
            case 2: return this.u5;
            case 10: return this.u5;
            case 12: return 0;
            case 11: return this.u5;
        }
        return this.u5;
    };
    DataToolTipLayer.prototype.te = function (a) {
        var b = [a];
        switch (a) {
            case 1:
                b = [2, 3];
                break;
            case 2:
                b = [1, 3];
                break;
            case 3:
                b = [1, 2];
                break;
            case 4:
                b = [8, 7, 3];
                break;
            case 5:
                b = [7, 8, 3];
                break;
            case 6:
                b = [9, 8, 4, 3];
                break;
            case 7:
                b = [5, 4, 2];
                break;
            case 8:
                b = [4, 5, 3];
                break;
            case 9:
                b = [6, 4, 8, 3];
                break;
            case 10:
                b = [11, 12];
                break;
            case 11:
                b = [10, 12];
                break;
            case 12:
                b = [10, 11];
                break;
            case 13: break;
            case 14: break;
            case 15: break;
        }
        return b;
    };
    DataToolTipLayer.prototype.td = function (a) {
        var b = [a];
        switch (a) {
            case 1:
                b = [2, 3];
                break;
            case 2:
                b = [1, 3];
                break;
            case 3:
                b = [1, 2];
                break;
            case 4:
                b = [8, 7, 3];
                break;
            case 5:
                b = [7, 8, 1];
                break;
            case 6:
                b = [9, 8, 4, 3];
                break;
            case 7:
                b = [5, 4, 2];
                break;
            case 8:
                b = [4, 5, 3];
                break;
            case 9:
                b = [6, 4, 8, 3];
                break;
            case 10:
                b = [11, 12];
                break;
            case 11:
                b = [10, 12];
                break;
            case 12:
                b = [10, 11];
                break;
            case 13: break;
            case 14: break;
            case 15: break;
        }
        return b;
    };
    DataToolTipLayer.prototype.uv = function (a, b, c, d) {
        return !(this.us(a, b, c) || this.ut(a, b, c, d));
    };
    DataToolTipLayer.prototype.uw = function (a, b, c, d) {
        return !(this.uu(a, b, c) || this.ur(a, b, c, d));
    };
    DataToolTipLayer.prototype.yj = function (a) {
        var b = new List$1(DataTooltipCollisionInfo.$, 0);
        for (var c = 0; c < a.f.count; c++) {
            var d = new DataTooltipCollisionInfo();
            d.d = c;
            d.e = { $type: Point_$type, x: a.f._inner[c], y: a.g._inner[c] };
            d.c = a.k._inner[c];
            d.a = a.j._inner[c];
            d.b = a.m._inner[c];
            if (isNaN_(d.e.x) || isNaN_(d.e.y)) {
                continue;
            }
            b.add(d);
        }
        b.aa(function (e, f) {
            if (e.e.y < f.e.y) {
                return -1;
            }
            if (e.e.y > f.e.y) {
                return 1;
            }
            if (e.b < f.b) {
                return -1;
            }
            if (e.b > f.b) {
                return 1;
            }
            return 0;
        });
        var e = this.up(b);
        if (!e) {
            return;
        }
        for (var f = 0; f < b.count - 1; f++) {
            var g = b._inner[f];
            var h = b._inner[f + 1];
            var i = new Rect(0, g.e.x, g.e.y, g.c, g.a);
            var j = new Rect(0, h.e.x, h.e.y, h.c, h.a);
            if (i.intersectsWith(j) || i.top > j.bottom) {
                h.e = { $type: Point_$type, x: h.e.x, y: i.bottom + 1 };
            }
        }
        if (b._inner[b.count - 1].e.y + b._inner[b.count - 1].a > this.b1.bu.height) {
            b._inner[b.count - 1].e = { $type: Point_$type, x: b._inner[b.count - 1].e.x, y: b._inner[b.count - 1].e.y - ((b._inner[b.count - 1].e.y + b._inner[b.count - 1].a) - this.b1.bu.height) };
        }
        for (var k = b.count - 1; k >= 1; k--) {
            var l = b._inner[k];
            var m = b._inner[k - 1];
            var n = new Rect(0, l.e.x, l.e.y, l.c, l.a);
            var o = new Rect(0, m.e.x, m.e.y, m.c, m.a);
            if (n.intersectsWith(o) || n.top < o.bottom) {
                m.e = { $type: Point_$type, x: m.e.x, y: n.top - (o.height + 1) };
            }
        }
        for (var p = 0; p < b.count; p++) {
            var q = b._inner[p].d;
            var r = b._inner[p];
            a.f._inner[q] = r.e.x;
            a.g._inner[q] = r.e.y;
        }
    };
    DataToolTipLayer.prototype.up = function (a) {
        if (a.count <= 1) {
            return false;
        }
        var b = this.b1.bu;
        for (var c = 0; c < a.count - 1; c++) {
            var d = a._inner[c];
            var e = a._inner[c + 1];
            var f = new Rect(0, d.e.x, d.e.y, d.c, d.a);
            var g = new Rect(0, e.e.x, e.e.y, e.c, e.a);
            if (f.intersectsWith(g)) {
                return true;
            }
        }
        return false;
    };
    DataToolTipLayer.prototype.yn = function (a, b, c, d, e) {
        var f = this.ry(a);
        if (!f.c) {
            return;
        }
        var g = a.ps(f.d, c, d);
        var h = this.t4.b6;
        var i = this.s8;
        if (!c) {
            i = this.px(g);
        }
        var j = a.hy(i);
        var k = h.item(e);
        var l = this.b1.bu;
        var m = this.t4.b5(k);
        if (!Base.equalsStatic(m.target, this.ce)) {
            m.target = this.ce;
        }
        m.includedSeries = [a.dataLegendKey];
        this.yl(m);
        m.targetCursorPositionX = this.s8.x;
        m.targetCursorPositionY = this.s8.y;
        if (!this.t4.b8(k, a)) {
            return;
        }
        var n = this.t4.cn(k);
        b.i.add1(k);
        var o = g.x;
        var p = g.x;
        p = Math.max(p, l.left);
        p = Math.min(p, l.right);
        b.l.add(p);
        var q = g.y;
        q = Math.max(q, l.top);
        q = Math.min(q, l.bottom);
        b.m.add(q);
        var r = DeviceUtils.g(10);
        var s = g.x + r;
        if (s + n.width > l.right) {
            s = (o - n.width) - r;
        }
        if (s < l.left) {
            s = l.left;
        }
        b.f.add(s);
        var t = (g.y - n.height) - r;
        if (t + n.height > l.bottom) {
            t = (l.bottom - n.height) - r;
        }
        if (t < l.top) {
            t = l.top;
        }
        b.g.add(t);
        b.k.add(n.width);
        b.j.add(n.height);
        var u = this.o5;
        if (u == null) {
            u = this.o9;
        }
        if (u == null) {
            u = a.o5;
        }
        b.h.add(u);
    };
    DataToolTipLayer.prototype.ym = function (a, b, c) {
        var e_6, _a;
        this.ts = this.tv();
        this.tw = this.tz();
        var d = a.f;
        var e = a.e;
        var f = 0;
        var g = this.t4.b6.item(0);
        this.t4.b8(g, null);
        var h = this.t4.b5(g);
        if (!Base.equalsStatic(h.target, this.ce)) {
            h.target = this.ce;
        }
        var i = new List$1(String_$type, 0);
        var j = this.tj();
        if (j != null) {
            try {
                for (var _b = __values(fromEnum(j.db())), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var k = _c.value;
                    if (k.isStacked) {
                        k.lf(function (l) {
                            i.add(l.dataLegendKey);
                            return true;
                        });
                    }
                    else {
                        i.add(k.dataLegendKey);
                    }
                }
            }
            catch (e_6_1) {
                e_6 = { error: e_6_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_6)
                        throw e_6.error;
                }
            }
            h.includedSeries = i.toArray();
        }
        else {
            h.includedSeries = null;
        }
        this.yl(h);
        h.targetCursorPositionX = this.s8.x;
        h.targetCursorPositionY = this.s8.y;
        var l = this.t4.cn(g);
        var m = 0;
        var n = 0;
        var o = 0;
        var p = 0;
        var q = false;
        var r = false;
        o = d.x;
        p = d.y;
        var s = this.b1.bu;
        var t = this.t4.co();
        var u = this.aap();
        var v = this.aal(u, l, e, d);
        var w = v.x;
        var x = v.y;
        {
        }
        b.l.add(w);
        b.m.add(x);
        b.f.add(w);
        b.g.add(x);
        b.k.add(l.width);
        b.j.add(l.height);
        b.i.add1(g);
        var y = null;
        b.h.add(y);
        this.t4.b6.count = 1;
    };
    DataToolTipLayer.prototype.v9 = function (a) {
        return a.toolTip;
    };
    DataToolTipLayer.prototype.r8 = function (a, b) {
        _super.prototype.r8.call(this, a, b);
        var c = a;
        var d = c.m.count;
        var e = b.bu.left;
        var f = b.bu.right;
        var g = b.bu.top;
        var h = b.bu.bottom;
        for (var i = 0; i < d; i++) {
            if (isNaN_(c.l._inner[i]) || isNaN_(c.m._inner[i]) || isNaN_(c.f._inner[i]) || isNaN_(c.g._inner[i])) {
                this.t4.cf(c.i._inner[i]);
                continue;
            }
            var j = c.f._inner[i];
            var k = c.g._inner[i];
            var l = c.k._inner[i];
            var m = c.j._inner[i];
            var n = false;
            if (n) {
                this.t4.cf(c.i._inner[i]);
                continue;
            }
            var o = c.i._inner[i];
            var p = Math.min(c.f._inner[i], c.l._inner[i]);
            var q = Math.min(c.g._inner[i], c.m._inner[i]);
            var r = c.l._inner[i] - c.f._inner[i];
            var s = c.m._inner[i] - c.g._inner[i];
            if (o != null) {
                this.t4.ch(o, p, q, r, s);
            }
        }
    };
    DataToolTipLayer.prototype.ep = function () {
        return true;
    };
    Object.defineProperty(DataToolTipLayer.prototype, "tt", {
        get: function () {
            return this.ts;
        },
        set: function (a) {
            var b = this.ts;
            this.ts = a;
            if (b != this.ts) {
                this.raisePropertyChanged("ActualGroupedPositionModeX", enumGetBox(DataTooltipGroupedPositionX_$type, b), enumGetBox(DataTooltipGroupedPositionX_$type, this.ts));
            }
        },
        enumerable: false,
        configurable: true
    });
    DataToolTipLayer.prototype.tv = function () {
        var e_7, _a;
        if (this.ce == null) {
            return 2;
        }
        var a = false;
        var b = false;
        var c = false;
        var d = false;
        var e = this.tj();
        if (e == null) {
            return 2;
        }
        try {
            for (var _b = __values(fromEnum(e.de)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var f = _c.value;
                if (f.dk) {
                    a = true;
                }
                if (f.isVertical) {
                    b = true;
                }
                if (f.d9) {
                    c = true;
                }
                if (f.ef) {
                    d = true;
                }
            }
        }
        catch (e_7_1) {
            e_7 = { error: e_7_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_7)
                    throw e_7.error;
            }
        }
        var g = ((function () {
            var $ret = new HashSet$1(DataTooltipGroupedPositionX_$type, 0);
            $ret.add_1(1);
            $ret.add_1(2);
            $ret.add_1(3);
            $ret.add_1(4);
            $ret.add_1(5);
            $ret.add_1(6);
            $ret.add_1(7);
            $ret.add_1(8);
            $ret.add_1(9);
            return $ret;
        })());
        var h = g.contains(this.tu);
        if (this.tu != 0) {
            if (h && b) {
                return 11;
            }
            return this.tu;
        }
        if (c || d) {
            return 11;
        }
        if (b) {
            return 11;
        }
        if (a) {
            return 8;
        }
        return 8;
    };
    Object.defineProperty(DataToolTipLayer.prototype, "tx", {
        get: function () {
            return this.tw;
        },
        set: function (a) {
            var b = this.tw;
            this.tw = a;
            if (b != this.tw) {
                this.raisePropertyChanged("ActualPositionModeY", enumGetBox(DataTooltipGroupedPositionY_$type, b), enumGetBox(DataTooltipGroupedPositionY_$type, this.tw));
            }
        },
        enumerable: false,
        configurable: true
    });
    DataToolTipLayer.prototype.tz = function () {
        var e_8, _a;
        if (this.ce == null) {
            return 11;
        }
        var a = false;
        var b = false;
        var c = false;
        var d = this.tj();
        if (d == null) {
            return 11;
        }
        try {
            for (var _b = __values(fromEnum(d.db())), _c = _b.next(); !_c.done; _c = _b.next()) {
                var e = _c.value;
                if (e.isVertical) {
                    a = true;
                }
                if (e.d9) {
                    b = true;
                }
                if (e.ef) {
                    c = true;
                }
            }
        }
        catch (e_8_1) {
            e_8 = { error: e_8_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_8)
                    throw e_8.error;
            }
        }
        var f = ((function () {
            var $ret = new HashSet$1(DataTooltipGroupedPositionY_$type, 0);
            $ret.add_1(1);
            $ret.add_1(2);
            $ret.add_1(3);
            $ret.add_1(4);
            $ret.add_1(5);
            $ret.add_1(6);
            $ret.add_1(7);
            $ret.add_1(8);
            $ret.add_1(9);
            return $ret;
        })());
        var g = f.contains(this.ty);
        if (this.ty != 0) {
            if (g && !a) {
                return 11;
            }
            return this.ty;
        }
        if (b || c) {
            return 11;
        }
        if (a) {
            return 8;
        }
        if (!a) {
            return 11;
        }
        return 11;
    };
    Object.defineProperty(DataToolTipLayer.prototype, "uo", {
        get: function () {
            return this.uf;
        },
        set: function (a) {
            var b = this.uf;
            this.uf = a;
            if (b != this.uf) {
                this.raisePropertyChanged("ValueTextStyle", b, this.uf);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataToolTipLayer.prototype, "ug", {
        get: function () {
            return this.t7;
        },
        set: function (a) {
            var b = this.t7;
            this.t7 = a;
            if (b != this.t7) {
                this.raisePropertyChanged("HeaderTextStyle", b, this.t7);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataToolTipLayer.prototype, "uj", {
        get: function () {
            return this.ua;
        },
        set: function (a) {
            var b = this.ua;
            this.ua = a;
            if (b != this.ua) {
                this.raisePropertyChanged("SummaryTitleTextStyle", b, this.ua);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataToolTipLayer.prototype, "ul", {
        get: function () {
            return this.uc;
        },
        set: function (a) {
            var b = this.uc;
            this.uc = a;
            if (b != this.uc) {
                this.raisePropertyChanged("SummaryValueTextStyle", b, this.uc);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataToolTipLayer.prototype, "ui", {
        get: function () {
            return this.t9;
        },
        set: function (a) {
            var b = this.t9;
            this.t9 = a;
            if (b != this.t9) {
                this.raisePropertyChanged("SummaryLabelTextStyle", b, this.t9);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataToolTipLayer.prototype, "uk", {
        get: function () {
            return this.ub;
        },
        set: function (a) {
            var b = this.ub;
            this.ub = a;
            if (b != this.ub) {
                this.raisePropertyChanged("SummaryUnitsTextStyle", b, this.ub);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataToolTipLayer.prototype, "un", {
        get: function () {
            return this.ue;
        },
        set: function (a) {
            var b = this.ue;
            this.ue = a;
            if (b != this.ue) {
                this.raisePropertyChanged("UnitsTextStyle", b, this.ue);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataToolTipLayer.prototype, "um", {
        get: function () {
            return this.ud;
        },
        set: function (a) {
            var b = this.ud;
            this.ud = a;
            if (b != this.ud) {
                this.raisePropertyChanged("TitleTextStyle", b, this.ud);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataToolTipLayer.prototype, "uh", {
        get: function () {
            return this.t8;
        },
        set: function (a) {
            var b = this.t8;
            this.t8 = a;
            if (b != this.t8) {
                this.raisePropertyChanged("LabelTextStyle", b, this.t8);
            }
        },
        enumerable: false,
        configurable: true
    });
    DataToolTipLayer.$t = markType(DataToolTipLayer, 'DataToolTipLayer', AnnotationLayer.$);
    DataToolTipLayer.$$p = markDep(DependencyProperty, PropertyMetadata, DataToolTipLayer, 'raisePropertyChanged', ['BadgeMargin:aar:yp', [Thickness.$, new Thickness(1, 0, 0, 0, 0)], 'BadgeShape:t6:yq', [LegendItemBadgeShape_$type, enumGetBox(LegendItemBadgeShape_$type, 0)], 'DefaultPositionOffsetX:u5:yr', [1, DeviceUtils.g(10)], 'DefaultPositionOffsetY:u6:ys', [1, DeviceUtils.g(10)], 'ExcludedColumns:tb:yt', [Array_$type, null], 'ExcludedSeries:tc:yu', [Array_$type, null], 'GroupedPositionModeX:tu:yv', [DataTooltipGroupedPositionX_$type, enumGetBox(DataTooltipGroupedPositionX_$type, 0)], 'GroupedPositionModeY:ty:yw', [DataTooltipGroupedPositionY_$type, enumGetBox(DataTooltipGroupedPositionY_$type, 0)], 'GroupingMode:t2:yx', [DataToolTipLayerGroupingMode_$type, enumGetBox(DataToolTipLayerGroupingMode_$type, 0)], 'HeaderFormatCulture:wm:yy', [2, stringEmpty()], 'HeaderFormatDate:tm:yz', [DataLegendHeaderDateMode_$type, enumGetBox(DataLegendHeaderDateMode_$type, 0)], 'HeaderFormatSpecifiers:tf:y0', [Array_$type, null], 'HeaderFormatString:wq:y1', [2, null], 'HeaderFormatTime:tn:y2', [DataLegendHeaderTimeMode_$type, enumGetBox(DataLegendHeaderTimeMode_$type, 0)], 'HeaderRowMargin:aas:y3', [Thickness.$, new Thickness(0, 5)], 'HeaderRowVisible:uq:y4', [0, true], 'HeaderTextColor:aac:y5', [Brush.$, null], 'HeaderTextMargin:aat:y6', [Thickness.$, new Thickness(1, 2, 0, 0, 0)], 'HeaderText:wv:y7', [2, null], 'IncludedColumns:tg:y8', [Array_$type, null], 'IncludedSeries:th:y9', [Array_$type, null], 'LabelDisplayMode:to:za', [DataLegendLabelMode_$type, enumGetBox(DataLegendLabelMode_$type, 0)], 'LabelTextColor:aad:zb', [Brush.$, null], 'LabelTextMargin:aau:zc', [Thickness.$, new Thickness(1, 8, 0, 0, 0)], 'PositionOffsetX:u7:zd', [1, NaN], 'PositionOffsetY:u8:ze', [1, NaN], 'ShouldUpdateWhenSeriesDataChanges:ux:zf', [0, true], 'SummaryLabelTextColor:aae:zg', [Brush.$, null], 'SummaryLabelText:w9:zh', [2, null], 'SummaryRowMargin:aav:zi', [Thickness.$, new Thickness(0, 5)], 'SummaryTitleTextColor:aaf:zj', [Brush.$, null], 'SummaryTitleTextMargin:aaw:zk', [Thickness.$, new Thickness(1, 2, 0, 0, 0)], 'SummaryTitleText:xe:zl', [2, null], 'SummaryType:tp:zm', [DataLegendSummaryType_$type, enumGetBox(DataLegendSummaryType_$type, 0)], 'SummaryUnitsTextColor:aag:zn', [Brush.$, null], 'SummaryUnitsText:xk:zo', [2, null], 'SummaryValueTextColor:aah:zp', [Brush.$, null], 'TargetAxis:tk:zq', [Axis.$, null], 'TitleTextColor:aai:zr', [Brush.$, null], 'TitleTextMargin:aax:zs', [Thickness.$, new Thickness(1, 0, 0, 0, 0)], 'UnitsDisplayMode:tq:zt', [DataLegendUnitsMode_$type, enumGetBox(DataLegendUnitsMode_$type, 0)], 'UnitsTextColor:aaj:zu', [Brush.$, null], 'UnitsTextMargin:aay:zv', [Thickness.$, new Thickness(1, 0, 0, 0, 0)], 'UnitsText:xv:zw', [2, null], 'UseInterpolation:uy:zx', [0, false], 'ValueFormatAbbreviation:tl:zy', [DataAbbreviationMode_$type, enumGetBox(DataAbbreviationMode_$type, 0)], 'ValueFormatCulture:x2:zz', [2, stringEmpty()], 'ValueFormatMaxFractions:v7:z0', [1, -1], 'ValueFormatMinFractions:v8:z1', [1, -1], 'ValueFormatMode:tr:z2', [DataLegendValueMode_$type, enumGetBox(DataLegendValueMode_$type, 0)], 'ValueFormatSpecifiers:ti:z3', [Array_$type, null], 'ValueFormatString:x8:z4', [2, null], 'ValueFormatUseGrouping:uz:z5', [0, true], 'ValueRowMargin:aaz:z6', [Thickness.$, new Thickness(0, 5)], 'ValueRowVisible:u0:z7', [0, true], 'ValueTextColor:aak:z8', [Brush.$, null], 'ValueTextMargin:aa0:z9', [Thickness.$, new Thickness(1, 2, 0, 2, 0)], 'ValueTextUseSeriesColors:u1:aaa', [0, false], 'ValueTextWhenMissingData:yh:aab', [2, "N/A"]]);
    return DataToolTipLayer;
}(AnnotationLayer));
export { DataToolTipLayer };
/**
 * @hidden
 */
var DataToolTipLayerView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(DataToolTipLayerView, _super);
    function DataToolTipLayerView(a) {
        var _this = _super.call(this, a) || this;
        _this.b6 = null;
        _this.b9 = null;
        _this.b4 = null;
        _this.b7 = false;
        _this._htmlTest = null;
        _this.b4 = a;
        _this.htmlTest = /^[^<]*(<[\w\W]+>)[^>]*$/;
        _this.b9 = new List$1(PointerTooltip.$, 0);
        return _this;
    }
    DataToolTipLayerView.prototype.aj = function () {
        _super.prototype.aj.call(this);
        for (var a = 0; a < this.b6.a.count; a++) {
            this.b6.a._inner[a].br();
        }
        for (var b = 0; b < this.b6.b.count; b++) {
            this.b6.b._inner[b].br();
        }
        this.b6.clear();
    };
    DataToolTipLayerView.prototype.ca = function () {
        var a = new PointerTooltip();
        a.bw(this.e.he);
        a._visibility = 1;
        a.ap = this.e.ce.cu.k;
        var b = null;
        if (TypeRegistrar.isRegistered("XamDataLegend")) {
            b = TypeRegistrar.create("XamDataLegend");
        }
        b.pixelScalingRatio = 1;
        if (this.e.ce != null) {
            var c = this.e.ce.cu.j.ae.createElement("div");
            var ren_ = this.e.ce.cu.j.ae.getSubRenderer(c);
            var len_ = b;
            len_.provideContainer(ren_);
        }
        a.ai = typeCast(IOnDemandRender_$type, b);
        a.ai.shouldOnDemandRender = true;
        this.b9.add(a);
        return a;
    };
    DataToolTipLayerView.prototype.cc = function (a) {
        var b = a;
    };
    DataToolTipLayerView.prototype.ce = function (a) {
        var b = a;
        b._visibility = 1;
    };
    DataToolTipLayerView.prototype.cd = function (a) {
        var b = a;
        b.bz();
        b.content = null;
        this.b9.remove1(a);
    };
    DataToolTipLayerView.prototype.as = function () {
        var _this = this;
        _super.prototype.as.call(this);
        this.b6 = ((function () {
            var $ret = new Pool$1(Base.$);
            $ret.create = runOn(_this, _this.ca);
            $ret.activate = runOn(_this, _this.cc);
            $ret.disactivate = runOn(_this, _this.ce);
            $ret.destroy = runOn(_this, _this.cd);
            return $ret;
        })());
    };
    Object.defineProperty(DataToolTipLayerView.prototype, "htmlTest", {
        get: function () {
            return this._htmlTest;
        },
        set: function (a) {
            this._htmlTest = a;
        },
        enumerable: false,
        configurable: true
    });
    DataToolTipLayerView.prototype.b8 = function (a, b) {
        var c = a;
        var d = c.ai;
        return true;
    };
    DataToolTipLayerView.prototype.cn = function (a) {
        var b = a;
        var c = new Size(1, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY);
        b.cy = 1;
        var d = b.cx(new Size(1, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY));
        b.cy = 0;
        return d;
    };
    DataToolTipLayerView.prototype.cm = function () {
        if (this.e.ce != null) {
            var a = this.e.ce.tc();
            var b = this.e.ce.cu.a8;
            var c = this.e.ce.cu.a7;
            return new Rect(0, 0, 0, b, c);
        }
        return Rect.empty;
    };
    DataToolTipLayerView.prototype.cl = function () {
        if (this.e.ce != null) {
            var a = this.e.ce.tc();
            var b = this.e.ce.cu.a8;
            var c = this.e.ce.cu.a7;
            return new Rect(0, 0, 0, b, c);
        }
        return Rect.empty;
    };
    DataToolTipLayerView.prototype.ck = function () {
        var a = 0;
        var b = 0;
        if (this.e.ce != null) {
            var c = this.e.ce.tc();
            a += c.x;
            b += c.y;
            var d = this.e.ce.cu.a8;
            var e = this.e.ce.cu.a7;
            return new Rect(0, a, b, d, e);
        }
        return Rect.empty;
    };
    DataToolTipLayerView.prototype.cj = function (a) {
        var b = 0;
        var c = 0;
        if (this.e.ce != null) {
            var d = this.e.ce.tc();
            b += d.x;
            c += d.y;
        }
        return { $type: Point_$type, x: b + a.x, y: c + a.y };
    };
    DataToolTipLayerView.prototype.ch = function (a, b, c, d, e) {
        var f = null;
        if (this.e.ce != null) {
            f = this.e.ce.cu.j.i();
        }
        var g = a;
        if (g == null) {
            return;
        }
        if (d == 0 && e == 0) {
            g.cy = 1;
        }
        else {
            g.cy = 0;
        }
        g.aq = f;
        g.cs = { $type: Point_$type, x: d, y: e };
        g._visibility = 0;
        g.n = b;
        g.o = c;
    };
    DataToolTipLayerView.prototype.co = function () {
        var a = (window.innerWidth);
        var b = (window.innerHeight);
        return new Size(1, a, b);
    };
    DataToolTipLayerView.prototype.cf = function (a) {
        if (a != null) {
            var b = a;
            b._visibility = 1;
        }
    };
    DataToolTipLayerView.prototype.ci = function () {
        if (this.e.ce == null) {
            this.cg(true);
        }
    };
    DataToolTipLayerView.prototype.a6 = function (a, b) {
        _super.prototype.a6.call(this, a, b);
        if (b) {
            return;
        }
        var c = 0;
        var d = 0;
        var e = this.e.ce;
        if (e != null) {
            var f = e.cu.j.b8();
            c += f.x;
            d += f.y;
        }
        for (var g = 0; g < this.b9.count; g++) {
            this.b9._inner[g].by(this.b9._inner[g].n + c, this.b9._inner[g].o + d);
        }
    };
    DataToolTipLayerView.prototype.al = function (a) {
        _super.prototype.al.call(this, a);
        for (var b = 0; b < this.b9.count; b++) {
            var c = this.b9._inner[b];
            var d = 0;
            var e = 0;
            if (this.e.ce != null) {
                var f = this.e.ce.tc();
                d += f.x;
                e += f.y;
            }
            var g = c.a5();
            var h = c.n - d;
            var i = c.o - e;
            var j = c.ai;
            var k = null;
            if (j != null) {
                k = j.exportVisualData();
            }
            this.e.a9.addPointerTooltipWithDataLegend(a, g, h, i, k);
        }
    };
    DataToolTipLayerView.prototype.b5 = function (a) {
        var b = a;
        return b.ai;
    };
    DataToolTipLayerView.prototype.cg = function (a) {
        this.aq();
        for (var b = 0; b < this.b9.count; b++) {
            this.cf(this.b9._inner[b]);
            if (a) {
                this.b9._inner[b].bs();
            }
        }
    };
    DataToolTipLayerView.$t = markType(DataToolTipLayerView, 'DataToolTipLayerView', AnnotationLayerView.$);
    return DataToolTipLayerView;
}(AnnotationLayerView));
export { DataToolTipLayerView };
